export default "../../src/img/spinner.gif";